module.exports = __webpack_public_path__ + "static/media/everyday_digital_190_year.ab240335.png";